import { getBreakingArticles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function BreakingNews() {
  const breakingArticles = getBreakingArticles();

  if (breakingArticles.length === 0) return null;

  return (
    <section className="py-8 md:py-12 px-4 md:px-6 bg-accent-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-sm font-bold">
              <span className="w-2 h-2 rounded-full bg-background-50 animate-pulse"></span>
              重磅爆料
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              独家追踪
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
          {breakingArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}